<template>
  <v-dialog v-model="isOpen" :fullscreen="fullscreen" :max-width="max_width" :persistent="persistent">
    <v-card v-if="!content_filled">
      <v-toolbar color="toolbar" dark>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <component :is="component" v-model:model2="model2.value" v-bind="props" @close="close"/>
      </v-card-text>
    </v-card>
    <component :is="component" v-if="content_filled" v-model:model2="model2.value" v-bind="props" @close="close"/>
  </v-dialog>
</template>

<script lang="ts" setup>
import {ref} from 'vue';

const isOpen = ref(false);
const component = ref<any>(null);
const props = ref<any>({});
const title = ref<string>('Dialog');
const max_width = ref<number>();
const content_filled = ref<boolean>(false);
const fullscreen = ref<boolean>(false);
const persistent = ref<boolean>(false);
const model2 = ref<any>(0);

function open(comp: any, compProps = {}, options: {
  contentFilled: boolean,
  dialogTitle: string,
  maxWidth: number,
  fullscreen: boolean,
  persistent: boolean,
  model2: any
}) {
  component.value = comp;
  props.value = compProps;
  title.value = options.dialogTitle ?? title.value;
  max_width.value = options.maxWidth ?? max_width.value;
  isOpen.value = true;
  content_filled.value = options.contentFilled ?? content_filled.value;
  fullscreen.value = options.fullscreen ?? fullscreen.value;
  persistent.value = options.persistent ?? persistent.value;
  model2.value = options.model2 ?? model2.value;
}

function close() {
  isOpen.value = false;
}

defineExpose({open, close});
</script>
